module.exports = __webpack_public_path__ + "img/horizontal_3_6_r_8004.e901f0d6.png";